"use client";

import React, { useEffect, useState } from "react";
import classNames from "classnames";

import Dropdown from "react-bootstrap/lib/Dropdown";
import MenuItem from "react-bootstrap/lib/MenuItem";
import DropdownMenu from "react-bootstrap/lib/DropdownMenu";
import DropdownToggle from "react-bootstrap/lib/DropdownToggle";

import style from "./main.module.scss";

interface DropdownProps {
  id?: string;
  initValue?: number;
  customClass?: string;
  onChange?: Function;
  placeHolder?: string;
  options: Array<any>;
  renderLabel?: Function;
  renderHeadValue?: Function;
  disabled?: boolean;
  dropdownClass?: string;
  toggleBtnClass?: string;
  menuItemsClass?: string;
  overlayClass?: string;
  parentLabel?: string;
  shouldRenderHeadValue?: boolean;
  renderDropdownAsBottomModal: boolean;
  parentLabelClass?: string;
  buttonActiveClass?: string;
}

const BsDropdown = ({
  id = "custom-dropdown",
  initValue = 0,
  onChange = () => {},
  placeHolder = "",
  options = [],
  customClass = "",
  renderLabel,
  renderHeadValue,
  disabled = false,
  dropdownClass = "",
  toggleBtnClass = "",
  menuItemsClass = "",
  overlayClass = "",
  parentLabel = "",
  shouldRenderHeadValue = true,
  renderDropdownAsBottomModal = false,
  parentLabelClass = "",
  buttonActiveClass = "",
}: DropdownProps) => {
  const [value, setValue] = useState(initValue);
  const [isOpen, setIsOpen] = useState<boolean>();

  useEffect(() => {
    setValue(initValue);
  }, [initValue]);

  const onSelect = (idx) => {
    if (parentLabel && !idx && idx != 0) return; // This has been added for the case where we need cross button and title in the case of mobile above the dropdown list
    const selectedVal = options[idx];
    setValue(idx);
    onChange(selectedVal, id);
  };

  const selectedOption = options[value];

  const hasRenderLabel = typeof renderLabel === "function";
  const hasRenderHeadValue = typeof renderHeadValue === "function";

  const getHeadValue = () => {
    if (!shouldRenderHeadValue) {
      return null;
    }

    if (hasRenderHeadValue && selectedOption) return renderHeadValue(selectedOption);
    if (hasRenderLabel) return renderLabel({ active: true, option: selectedOption });
    return selectedOption?.label || placeHolder;
  };
  const headValue = getHeadValue();

  return (
    <Dropdown
      {...(Dropdown.defaultProps || {})}
      disabled={disabled}
      id={id}
      onSelect={onSelect}
      className={classNames({ [style.bsDropDownMenu]: renderDropdownAsBottomModal }, customClass)}
      onToggle={(val) => {
        setIsOpen(val);
      }}
    >
      <DropdownToggle
        {...(DropdownToggle.defaultProps || {})}
        className={classNames(toggleBtnClass, { [buttonActiveClass]: isOpen })}
      >
        {headValue}
      </DropdownToggle>

      <div
        className={classNames(
          { [style.dropDownOverlay]: renderDropdownAsBottomModal },
          overlayClass,
        )}
      ></div>
      <DropdownMenu
        {...(DropdownMenu.defaultProps || {})}
        className={classNames(
          { [style.dropdownMenuUl]: renderDropdownAsBottomModal },
          dropdownClass,
        )}
      >
        {parentLabel && ( // This has been added for the case where we need cross button and title in the case of mobile above the dropdown list
          <MenuItem {...(MenuItem.defaultProps || {})} className="mobile-label-wrap">
            <span className={classNames("labelMobile", parentLabelClass)}>{parentLabel}</span>
            <i className="iconClose" />
          </MenuItem>
        )}
        {options.map((option, idx) => {
          const { label, component } = option;
          const props = {
            active: idx == value,
            eventKey: idx,
            option,
          };
          const disabled = option.data?.disabled;

          if (component) {
            return <>{component}</>;
          }
          return (
            <MenuItem
              {...(MenuItem.defaultProps || {})}
              key={`dropdown-item-${idx}`}
              className={classNames(
                { [style.menuListItem]: renderDropdownAsBottomModal },
                menuItemsClass,
              )}
              disabled={disabled}
              {...props}
            >
              {hasRenderLabel ? renderLabel(props) : label}
            </MenuItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

export default BsDropdown;
